<ul
  #listContainer
  class="list"
  role="menu"
  [id]="uniqueListId"
  [attr.aria-label]="ariaLabel"
  [attr.aria-description]="'shared.ui.list.description' | translate"
  [tabindex]="ariaLabel ? '0' : '-1'"
  (keydown)="handleMenuKeydown($event)"
  (focus)="handleMenuFocus($event)"
>
  @for (item of items; track item; let idx = $index ) {
  <li
    libMenuItemContainer
    role="menuitem"
    class="list-item"
    [class.disabled]="disabled"
    [tabindex]="idx === currentIndex ? '0' : '-1'"
    (keydown)="handleKeydown($event, idx)"
    [attr.aria-label]="item.ariaLabel"
    [attr.aria-description]="item.ariaDescription"
  >
    <ng-container *ngIf="itemTemplate; else defaultItemTemplate">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item, index: idx }"></ng-container>
    </ng-container>

    <ng-template #defaultItemTemplate>
      {{ item.name }}
    </ng-template>
  </li>

  }
</ul>
